// The linked-customers response may come back as a tree — an org can nest
// child orgs under `consumers`. The Filter modal needs a flat list, and the
// listing APIs filter by org id, so options carry { value: id, label: name }.
export const flattenOrgOptions = (orgs, acc = []) => {
  if (!Array.isArray(orgs)) return acc
  for (const org of orgs) {
    if (org?.id != null && !acc.some((o) => o.value === org.id)) {
      acc.push({ value: org.id, label: org.name })
    }
    flattenOrgOptions(org?.consumers, acc)
  }
  return acc
}
